import { multilineTextToHtml } from "../DetailsForm/Presenter/Helpers/multilineTextToHtml";
import Modal from "react-bootstrap/Modal";
import { confirmable, createConfirmation } from "react-confirm";

const Confirmation = (props: {
  okLabel: string;
  cancelLabel: string;
  title: string;
  confirmationHTML: string;
  show: boolean;
  proceed: (isOk: boolean) => void;
  enableEscape: boolean;
}) => {
  return (
    <div className="static-modal">
      <Modal
        animation={true}
        show={props.show}
        onHide={() => props.proceed(false)}
        backdrop={props.enableEscape ? true : "static"}
        keyboard={props.enableEscape}
      >
        <Modal.Header>
          <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          dangerouslySetInnerHTML={{ __html: props.confirmationHTML }}
        ></Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            name="ok"
            className="btn btn-primary px-3 py-1"
            onClick={() => props.proceed(true)}
          >
            {props.okLabel}
          </button>
          <button
            type="button"
            name="ok"
            className="btn btn-secondary px-3 py-1"
            onClick={() => props.proceed(false)}
          >
            {props.cancelLabel}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

/**
 * Displays awaitable confirmation dialog.
 * @param title The dialog title
 * @param confirmation The message inside, can contain newline sequence (\r\n).
 * @param okLabel 
 * @param cancelLabel 
 * @param options 
 * @returns Promise<boolean> resolved with true (ok) or false (cancel)
 */
export function ConfirmDialog(
  title: string,
  confirmation: string,
  okLabel: string = "OK",
  cancelLabel: string = "Anuluj",
  options: any = {}
): Promise<boolean> {
  let confirmationHTML = multilineTextToHtml(confirmation) || "";
  return createConfirmation(confirmable(Confirmation))({
    title,
    confirmationHTML,
    okLabel,
    cancelLabel,
    ...options,
  }) as Promise<boolean>;
}
